<template>
    <div id="create-paintworkform-page">
        <ui5-label>
            {{ trans('pages.create_paintwork_form.instruction') }}
        </ui5-label>
        <spinner-text v-if="!paintshops">
            {{ trans('pages.create_paintwork_form.loading_paintshops') }}
        </spinner-text>
        <div
            class="paintshops"
            v-else
        >
            <ui5-segmented-button @selection-change="paintshopChanged">
                <ui5-segmented-button-item
                    v-for="paintshop in paintshops"
                    :pressed="selectedPaintshopId == paintshop.paintshopId"
                    :key="paintshop.paintshopId"
                    :value="paintshop.paintshopId"
                >
                    {{ paintshop.name }}
                </ui5-segmented-button-item>
            </ui5-segmented-button>
        </div>
        <div class="action-buttons">
            <ui5-button @click="$router.push('/menu')">
                {{ trans('pages.create_paintwork_form.cancel_button') }}
            </ui5-button>
            <ui5-button
                @click="createPaintworkForm"
                :disabled="selectedListIds.length == 0"
            >
                <spinner v-if="creating" />
                {{ trans('pages.create_paintwork_form.create_order_button') }}
            </ui5-button>
        </div>
        <div id="paintlistdiv">
            <spinner-text v-if="!paintLists">
                {{ trans('pages.create_paintwork_form.loading_paintlists') }}
            </spinner-text>
            <template v-else>
                <div v-if="paintLists.length == 0">
                    {{
                        trans('pages.create_paintwork_form.no_paintlists_found')
                    }}
                </div>
                <template v-else>
                    <div
                        class="paintlistrow"
                        v-for="paintList in paintLists"
                        :key="paintList.ID"
                    >
                        <input
                            class="paintworkformcheckbox"
                            type="checkbox"
                            :id="paintList.ID"
                            v-model="paintList.selected"
                        />
                        {{ getDescription(paintList) }}
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import paintshopApi from '../api/paintshop';
import paintWorkOrderApi from '../api/paintWorkOrder';
import optimizedPaintListApi from '../api/optimizedPaintList';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';
import { paintListTypeOptionById } from '../helpers/PaintListTypeHelper.js';

export default {
    components: { SpinnerText, Spinner },
    mixins: [localization],
    computed: {
        selectedListIds() {
            if (!this.paintLists) {
                return [];
            }
            return this.paintLists.filter((x) => x.selected).map((x) => x.ID);
        },
    },
    data() {
        return {
            creating: false,
            paintLists: null,
            paintshops: null,
            selectedPaintshopId: null,
        };
    },
    methods: {
        paintListTypeOptionById,
        paintshopChanged($event) {
            this.selectedPaintshopId =
                $event.detail.selectedItem.getAttribute('value');
            this.populateCreatePaintworkformList();
        },
        getDescription(paintlist) {
            return [
                `${paintlist.ID} (${this.trans(
                    'paint_lists.types.' +
                        this.paintListTypeOptionById(paintlist.typeId)?.key
                )})`,
                paintlist.deadline,
                `${paintlist.color.ralnr}${paintlist.color.raltype} ${paintlist.color.poedernr} ${paintlist.color.producent}`,
                `(${paintlist.color.description})`,
                paintlist.paintshop ? paintlist.paintshop.name : '',
                paintlist.productId,
                paintlist.name,
                paintlist.reference,
            ].join(' - ');
        },
        populateCreatePaintworkformList() {
            if (this.selectedPaintshopId) {
                this.paintLists = null;
                optimizedPaintListApi
                    .fetchToProcess(this.selectedPaintshopId)
                    .then((response) => {
                        this.paintLists = response.data.data.map((list) => ({
                            ...list,
                            selected: false,
                        }));
                    });
            }
        },
        populatePaintworkformPaintshops() {
            paintshopApi.list().then((response) => {
                this.paintshops = response.data.data;
                const selectedPaintshop = this.paintshops.find(
                    (x) => x.default == 1
                );
                this.selectedPaintshopId = selectedPaintshop
                    ? selectedPaintshop.paintshopId
                    : this.paintshops[0].paintshopId;
                this.populateCreatePaintworkformList();
            });
        },
        createPaintworkForm() {
            this.creating = true;
            paintWorkOrderApi
                .create(this.selectedListIds, true)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.create_paintwork_form.success_message'
                        )
                    );
                    this.$router.push('/menu');
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.create_paintwork_form.error_message')
                    );
                })
                .finally(() => {
                    this.creating = false;
                });
        },
    },
    mounted() {
        this.populatePaintworkformPaintshops();
    },
};
</script>
